import { render, staticRenderFns } from "./DatatableV1.vue?vue&type=template&id=cc69ce3c&scoped=true&"
import script from "./DatatableV1.vue?vue&type=script&lang=js&"
export * from "./DatatableV1.vue?vue&type=script&lang=js&"
import style0 from "./DatatableV1.vue?vue&type=style&index=0&id=cc69ce3c&prod&scoped=true&lang=css&"
import style1 from "./DatatableV1.vue?vue&type=style&index=1&id=cc69ce3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc69ce3c",
  null
  
)

export default component.exports